<template>
  <div class='app-container'>

    <icare-table
      ref='table'
      searchTip='请根据设备编号进行搜索'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='paginationConfig'
      methods-data='get_refund_order'
      params>
      <div>
        <span class='left-table'>订单号：</span>
        <el-input v-model='order_id' placeholder='请输入订单号' style='width: 200px;' clearable></el-input>
        <span class='left-table'>时间范围：</span>
        <el-date-picker
          v-model='findDateTime'
          type='datetimerange'
          align='right'
          start-placeholder='开始'
          end-placeholder='结止'
          format='yyyy-MM-dd HH:mm:ss'
          value-format='yyyy-MM-dd HH:mm:ss'
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
        <span class='left-table'>
          <el-button type='primary' icon='el-icon-search' @click='find'>查找</el-button>
        </span>
      </div>
    </icare-table>

    <el-dialog title='退款确认' :visible.sync='dialogVisible' width='30%' @closed='closeDialog'>
      <el-form label-width='160px' ref='form' :rules='rules' :model='form'>
        <el-form-item label='交易单号' prop='order_id'>
          <el-input v-model.number='form.order_id' disabled placeholder='请输入交易单号'></el-input>
        </el-form-item>
        <el-form-item label='充电开始时间' prop='create_time' v-if='payment_value!=null'>
          <el-input v-model.number='create_time' disabled placeholder='请输入充电开始时间'></el-input>
        </el-form-item>
        <el-form-item label='充电结束时间' prop='stop_time' v-if='payment_value!=null'>
          <el-input v-model.number='stop_time' disabled placeholder='请输入充电结束时间'></el-input>
        </el-form-item>
        <el-form-item label='购买金额(单位:元)' prop='stop_time' v-if='payment_value!=null'>
          <el-input v-model.number='form.cash' disabled placeholder='请输入充电结束时间'></el-input>
        </el-form-item>
        <el-form-item label='购买时长(单位:秒)' prop='stop_time' v-if='payment_value!=null'>
          <el-input v-model.number='payment_value' disabled placeholder='请输入充电结束时间'></el-input>
        </el-form-item>
        <el-form-item label='剩余时长(单位:秒)' prop='stop_time' v-if='payment_value!=null'>
          <el-input v-model.number='remaining_time' disabled placeholder='请输入充电结束时间'></el-input>
        </el-form-item>

        <el-form-item label='应退金额(元)' prop='refund_fee'>
          <el-input-number v-model='form.refund_fee' :precision='2' :step='0.1' :max='10'
                           style='width: 100%'></el-input-number>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='closeDialog'>取 消</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='refund'>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'

export default {
  name: 'get_refund_order',
  data() {
    return {
      paginationConfig: {
        order_id: '',
        start_time: '',
        end_time: ''
        // payment_status: ''
      },
      findDateTime: [],
      statusList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 'FINISH',
          label: '已支付'
        },
        {
          value: 'REFUND',
          label: '已退款'
        }
      ],
      order_id: '',
      payment_status: '',
      titleConfig: [
        {
          field: 'id',
          title: '流水号',
          visible: true
        },
        {
          field: 'order_id',
          title: '交易单号',
          visible: true
        },
        {
          field: 'refund_type',
          title: '退款类型',
          visible: true,
          fuc: val => {
            let v
            if (val == 'ORDER') {
              v = '<div style="color:#000000">后台申请退款</div>'
            } else if (val == 'APPLY') {
              v = '<div style="color:#409EFF">用户申请退款</div>'
            } else if (val == 'CHARGE_FAIL') {
              v = '<div style="color:#F56C6C">充电异常退款</div>'
            } else {
              v = '<div style="color:#E6A23C">其他退款</div>'
            }
            return v
          }
        },
        {
          field: 'cause',
          title: '退款原因',
          visible: true
        },
        {
          field: 'total',
          title: '应退金额',
          visible: true,
          fuc: val => {
            return val == undefined ? '0.00 元' : (val / 100).toFixed(2) + ' 元'
          }
        },
        {
          field: 'fee',
          title: '实退金额',
          visible: true,
          fuc: val => {
            return val == undefined ? '0.00 元' : (val / 100).toFixed(2) + ' 元'
          }
        },
        {
          field: 'platform_trade_code',
          title: '退款状态',
          visible: true,
          fuc: val => {
            let v
            if (val.length > 0) {
              v = '<div style="color:#67C23A">已退款</div>'
            } else {
              v = '<div style="color:#E6A23C">待处理</div>'
            }
            return v
          }
        },
        {
          field: 'refund_time',
          title: '退款时间',
          visible: true,
          fuc: function(title, item, row) {

            if (row.platform_trade_code.length <= 0) {
              return ''
            } else {
              return row.refund_time
            }
          }
        },
        {
          field: 'create_time',
          title: '申请时间',
          visible: true
        },
        {
          title: '操作',
          width: 80,
          option: true,
          children: [
            // {
            //   title: '充电订单',
            //   color: '#67C23A',
            //   icon: 'el-icon-document',
            //   fuc: row => {
            //     this.getOrder(row.id)
            //   }
            // },
            {
              title: '确认退款',
              color: '#F56C6C',
              icon: 'el-icon-document',
              fuc: row => {
                this.handleRefund(row)
              }
            }
          ]
        }
      ],
      formLabelWidth: '120px',
      offset: 10,
      analyseVisible: false,
      row: {},
      form: {},
      dialogVisible: false,
      create_time: null,
      stop_time: null,
      payment_value: null,
      refund_fee: null,
      remaining_time: null,
      rules: {
        order_id: [
          { required: true, message: '请输入交易订单', trigger: 'blur' }
        ],
        refund_fee: [
          { required: true, message: '请输入应退金额', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {
    this.paginationConfig.order_id = this.$route.query.order_id
    this.create_time = this.$route.query.create_time
    this.stop_time = this.$route.query.stop_time
    this.payment_value = this.$route.query.payment_value
    this.cash = this.$route.query.cash


  },
  mounted() {
  },
  methods: {
    find() {
      this.paginationConfig.order_id = this.order_id
      if (this.findDateTime != null && this.findDateTime.length === 2) {
        this.paginationConfig.start_time = this.findDateTime[0]
        this.paginationConfig.end_time = this.findDateTime[1]
      } else {
        this.paginationConfig.start_time = ''
        this.paginationConfig.end_time = ''
      }
      this.$refs.table.refresh()
    },

    statusSelect(v) {
      this.paginationConfig.payment_status = v
    },

    //关闭对话框
    closeDialog() {
      this.dialogVisible = false
      this.form = {}
      this.$refs['form'].resetFields()
      this.$refs['form'].clearValidate()
    },

    //
    handleRefund(row) {
      if (row.platform_trade_code.length > 0) {
        this.$message.warning('操作失败，该记录已退款')
        return
      }
      this.calRefundFee()
      this.dialogVisible = true

      var fee=this.payment_value==null ? row.total/100:this.refund_fee / 100

      this.form = Object.assign({ order_id: row.order_id, refund_fee: fee,cash:this.cash/100 })
    },
    refund() {

      if(this.form.refund_fee <=0){
        this.$message.warning('请输入应退款金额')
        return
      }

      this.$confirm('此操作给交易单号' + this.form.order_id + ' 退款' + this.form.refund_fee + '元, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //验证表单
        this.$refs.form.validate(valid => {
          if (valid) {
            let str = JSON.stringify({
              order_id: this.form.order_id,
              refund_fee: parseInt(this.form.refund_fee * 100)
            })
            gateway({
              func: 'set_refund_payment_order',
              params: str
            }).then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功')
                this.closeDialog();
                this.$refs.table.refresh()

              } else {
                this.$message.error('操作失败:' + res.msg)
              }
            })
          } else {
            return false
          }
        })
      }).catch(() => {

      })
    },

    getOrder(order_id) {
      let str = JSON.stringify({
        order_id: order_id
      })
      gateway({
        func: 'get_payment_order',
        params: str
      }).then(res => {
        if (res.code == 0) {
          if (res.result[0].device_type == 0) { // 充电仓
            this.$router.push({
              path: '/box_order',
              query: { order_id: order_id }
            })
          } else { //插座
            this.$router.push({
              path: '/socket_order',
              query: { order_id: order_id }
            })
          }
        }
      })
    },

    calRefundFee() {
      var dateBegin = new Date(this.create_time)
      var dateEnd = new Date(this.stop_time)
      var interval = parseInt((dateEnd.getTime() - dateBegin.getTime()) / 1000) //时间差的秒数
      console.log('充电时长(单位:秒)------', interval)
      var rTime = parseInt(this.payment_value) - parseInt(interval)
      console.log('剩余时长(单位:秒)------', rTime)
      this.remaining_time=rTime
      if (rTime > 0) {
        var vrate = (parseFloat(interval) / parseFloat(this.payment_value)).toFixed(2)
        console.log('充电时长比例(%)------', vrate)
        console.log('充电总金额(单位:分)-----', vrate * parseFloat(this.cash))
        console.log('充电总金额(单位:分)parseFloat-----', parseFloat(vrate * parseFloat(this.cash)))
        var refundFee = (parseFloat(this.cash) - parseFloat(vrate * parseFloat(this.cash))).toFixed(2)
        console.log('应退金额(单位:分)------', refundFee)
        this.refund_fee = refundFee
      }
    }
  }
}
</script>

<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}
</style>
